import { 
    GET_USER_CREDIT_INFO, 
    GET_USER_CREDIT_INFO_SUCCESS, 
    GET_USER_PCT_UNLOCK_HISTORY, 
    GET_USER_PCT_UNLOCK_HISTORY_SUCCESS, 
    SET_MY_CREDITS_LOADING 
} from "./actionTypes";

export const getUserCreditInfo = (data) => ({
    type: GET_USER_CREDIT_INFO,
    payload: data,
});

export const getUserCreditInfoSuccess = (data) => ({
    type: GET_USER_CREDIT_INFO_SUCCESS,
    payload: data,
});

export const setMyCreditsLoading = (loading) => ({
    type: SET_MY_CREDITS_LOADING,
    payload: loading,
});

export const getUserPctUnlockHistory = (data) => ({
    type: GET_USER_PCT_UNLOCK_HISTORY,
    payload: data,
});

export const getUserPctUnlockHistorySuccess = (data) => ({
    type: GET_USER_PCT_UNLOCK_HISTORY_SUCCESS,
    payload: data,
});